export default {
  edit_profile: 'Profil bearbeiten',
  my_account: 'Mein Konto',
  balance: 'Guthaben',
  available_for_withdrawal: 'Zur Auszahlung verfügbar',
  amount_in_hold: 'Betrag auf Halten',
  latest_news: 'Aktuelle Neuigkeiten',
  more_news: 'Weitere Nachrichten'
};